// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Step14Messages } from './Step14Messages'
import type { SaveStatus } from '@/hooks/useAutosave'

export function NewStep13Messages(props: { onSaveStatus: (s: SaveStatus) => void }) {
  return <Step14Messages {...props} />
}
